import i18next from 'i18next';
import fi from './fi';
import sv from './sv';
const i18n = (lang) => {
    var _a;
    return i18next.createInstance({
        lng: (_a = (lang || localStorage.getItem('gradingLang'))) !== null && _a !== void 0 ? _a : 'fi',
        fallbackLng: 'fi',
        ns: ['translation'],
        defaultNS: 'translation',
        react: { useSuspense: false },
        interpolation: { escapeValue: false },
        resources: getTranslationResources()
    }, (err, t) => {
        if (err)
            return console.log(err);
    });
};
function getTranslationResources() {
    return { fi: { translation: fi }, sv: { translation: sv } };
}
export default i18n;
//# sourceMappingURL=i18n.js.map